function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.964,
    height: 32,
    viewBox: "0 0 31.964 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10258"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46280",
    d: "m-16517.254 14206.595 5.1-2.661h5.574l3.3 1.437 3.506 3.037.781 1.377 7.965-2.878h2.545l1.49 1.5-.447 1.742-18.26 8.046-8.836-4.405z",
    transform: "translate(16518 -14187)",
    style: {
      fill: "#f8e6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8880",
    transform: "translate(11 5)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h12v9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46278",
    d: "M162.268 0a11.374 11.374 0 0 0-11.36 11.36 11.05 11.05 0 0 0 .371 2.873 15.677 15.677 0 0 1 4.275-.451 14.4 14.4 0 0 1 9.891 4.157 11.729 11.729 0 0 1 1.178 1.44l5.411-2.227a11.233 11.233 0 0 0 1.594-5.792A11.372 11.372 0 0 0 162.268 0zm-1.03 13.327L157.411 9.5l1.357-1.357 2.47 2.47 4.562-4.565 1.357 1.352z",
    transform: "translate(-146.303 .004)",
    style: {
      fill: "#00a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46279",
    d: "M102.128 281.413a3.232 3.232 0 0 1-1.811 1.994L82.7 290.939l-.39-.186c-7.933-3.766-8.995-4.336-9.235-4.521l1.379-1.4c1.082.563 5.363 2.618 8.288 4.006l16.822-7.194a1.314 1.314 0 0 0-1.018-2.422l-12.81 5.27-6.122-3.12.87-1.709 5.337 2.72 2.218-.915a7.679 7.679 0 0 0-1.347-1.92c-3.645-3.782-10.515-4.051-14.563-.614l-1.815-.9a1.665 1.665 0 0 1 .349-.378c4.739-4.246 13.037-3.981 17.411.554a9.616 9.616 0 0 1 1.744 2.522l7.994-3.29a3.234 3.234 0 0 1 4.314 3.971z",
    transform: "translate(-70.316 -258.939)",
    style: {
      fill: "#283045"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/Assets.f8fbb98118c5f1aabcabe2fcf3889e8b.svg";
export { ForwardRef as ReactComponent };